// Public client configuration. The publishable key is public by design: row-level security
// protects the data. Override per deployment with VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY.
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? 'https://fljlhyxnruwjdebdjtob.supabase.co';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? 'sb_publishable_8uQrjhlhF9-1X_t_6Y9u1Q_6YSSLL3z';
/** The Recover WhatsApp bot (Twilio sender). */
export const BOT_NUMBER = '+972535652393';
export const PRIVACY_EMAIL = 'privacy@twenty-six7.com';
